import React, { Component } from 'react'
import { CheckCircleOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Tabs, Button, Popconfirm, Modal, Input } from 'hljd'
import ImgGallery from '@common/ImgGallery'
import FollowUp from './FollowUp'
import Feedback from './Feedback'
import Distribution from './Distribution'
import DepositPaid from './DepositPaid'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import store from './store'
import storeUp from '../store'

const TabPane = Tabs.TabPane
const Item = Form.Item

@observer
export default class extends Component {
  UNSAFE_componentWillMount() {
    store.GetOrderFB('id=' + storeUp.id)
  }
  componentWillUnmount() {
    store.reset()
  }

  render() {
    const {
      fbStatus: { status },
      is_come
    } = storeUp

    const { is_exist, success } = store

    let _html
    if (status == 1 || status == 3 || status == 5) {
      _html = (
        <div style={{ textAlign: 'center' }}>
          {(status == 1 || status == 5) && (
            <Button
              onClick={store.showModifyModal}
              style={{ width: 115, marginRight: 8 }}
              type="primary"
            >
              修改客户需求
            </Button>
          )}
          <Button
            onClick={store.maintain}
            style={{ width: 90 }}
            type="ghost"
            disabled={status == 3}
          >
            退单
          </Button>
          {status == 3 && <span style={{ paddingLeft: 10 }}>(退单提交)</span>}
          {status == 5 && <span style={{ paddingLeft: 10 }}>(退单不通过)</span>}
        </div>
      )
    } else if (status == 2) {
      _html = (
        <div style={{ textAlign: 'center' }}>
          <Button
            onClick={store.showModifyModal}
            style={{ width: 90, marginRight: 8 }}
            type="primary"
          >
            重新提交
          </Button>
          <Button onClick={store.maintain} style={{ width: 90 }} type="ghost">
            退单
          </Button>
        </div>
      )
    } else if (status == 4) {
      _html = (
        <div style={{ textAlign: 'center' }}>
          <Button
            onClick={store.maintain}
            style={{ width: 90 }}
            type="ghost"
            disabled={true}
          >
            退单
          </Button>
          <span style={{ paddingLeft: 10 }}>(退单通过)</span>
        </div>
      )
    } else if (status == 0) {
      _html = (
        <div style={{ textAlign: 'center' }}>
          <Button
            onClick={store.showModifyModal}
            style={{ width: 115, marginRight: 8 }}
            type="primary"
          >
            修改客户需求
          </Button>
          <Button onClick={store.maintain} style={{ width: 90 }} type="ghost">
            退单
          </Button>
        </div>
      )
    } else if (status == '') {
      _html = (
        <div style={{ textAlign: 'center' }}>
          {
            <Popconfirm
              title="是否确定用户已到过酒店?"
              onConfirm={store.sendCome}
              okText="确定"
              cancelText="取消"
            >
              <Button
                style={{
                  width: 90,
                  marginRight: 8,
                  marginLeft: 13,
                  display: is_come === '0' ? 'inline-block' : 'none'
                }}
                type="primary"
              >
                确认到店
              </Button>
            </Popconfirm>
          }
          <Button
            onClick={store.showModal}
            style={{ width: 90, marginRight: 8 }}
            type={is_come === '0' ? 'ghost' : 'primary'}
          >
            提交审核
          </Button>
          <Popconfirm
            title="是否确定客户跟进失败?"
            onConfirm={store.sendFail}
            okText="确定"
            cancelText="取消"
          >
            <Button style={{ width: 90 }} type="ghost">
              跟进失败
            </Button>
          </Popconfirm>
        </div>
      )
    } else {
      _html = (
        <div style={{ textAlign: 'center' }}>
          {
            <Popconfirm
              title="是否确定用户已到过酒店?"
              onConfirm={store.sendCome}
              okText="确定"
              cancelText="取消"
            >
              <Button
                style={{
                  width: 90,
                  marginRight: 8,
                  marginLeft: 13,
                  display: is_come === '0' ? 'inline-block' : 'none'
                }}
                type="primary"
              >
                确认到店
              </Button>
            </Popconfirm>
          }
          <Button
            onClick={store.showModal}
            style={{ width: 90, marginRight: 8 }}
            type={is_come === '0' ? 'ghost' : 'primary'}
          >
            提交审核
          </Button>
          <Popconfirm
            title="是否确定客户跟进失败?"
            onConfirm={store.sendFail}
            okText="确定"
            cancelText="取消"
          >
            <Button style={{ width: 90 }} type="ghost">
              跟进失败
            </Button>
          </Popconfirm>
        </div>
      )
    }
    return (
      <div className={Styles.orderDynamic}>
        <Tabs
          defaultActiveKey={{ '0': '1', '1': '2' }[is_exist + '']}
          type="card"
        >
          <TabPane tab="订单跟进" key="1">
            <FollowUp />
          </TabPane>
          <TabPane tab="订单反馈" key="2">
            <Feedback />
          </TabPane>
          <TabPane tab="分配记录" key="3">
            <Distribution />
          </TabPane>
        </Tabs>

        <div
          className={Styles.areaBtn}
          style={{ paddingBottom: 15, background: '#fff' }}
        >
          {_html}
        </div>

        <DepositPaid />

        <Modal visible={store.tdVisible} footer={null} onCancel={store.hideWin}>
          <Item
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            required
            style={{ marginTop: 10 }}
            label="退单原因"
          >
            <Input
              onChange={store.resInput}
              style={{ marginTop: 8 }}
              type="textarea"
              rows={4}
            />
          </Item>
          <Item
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 18 }}
            label="凭证上传"
          >
            <em>上传有效凭证有助于通过审核，最多上传5张</em>
            <ImgGallery
              max={5}
              onRemove={store.tdRemoveImg}
              multiple={true}
              onOk={store.tdUpImg}
              imgList={store.tdImgs}
            />
          </Item>
          <div style={{ marginBottom: 30, marginTop: 36, textAlign: 'center' }}>
            <Button
              onClick={store.refundSend}
              style={{ marginRight: 36, width: 120 }}
              type="primary"
            >
              提交审核
            </Button>
            <Button onClick={store.hideWin} style={{ width: 120 }}>
              取消
            </Button>
          </div>
        </Modal>

        <Modal
          visible={success}
          footer={null}
          width={300}
          maskClosable={false}
          closable={false}
        >
          <div style={{ height: 100, lineHeight: '100px' }}>
            <p style={{ fontSize: 20, textAlign: 'center' }}>
              <CheckCircleOutlined
                style={{ color: '#00a854', fontSize: 20, marginRight: 10 }}
              />
              已成功确认到店
            </p>
          </div>
        </Modal>
      </div>
    )
  }
}
